import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from 'react-router-dom'
import { getCrumbsById } from '../selectors'
import NodeCrumbs from '../components/nodeCrumbs'

const mapStateToProps = (state, ownProps) => ({
  crumbs: getCrumbsById({
    state,
    id: ownProps.id,
  }),
})

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    null,
  ),
)(NodeCrumbs)



// WEBPACK FOOTER //
// ./src/modules/core/containers/nodeCrumbs.js